import { BaseResource } from 'utils/ApiUtils';

export default class Checklist extends BaseResource {
  static columns = [
    {
      title: "Inspection #",
      field: "InspectionNumber_Inspection"
    },
    { title: "Inspector", field: "Name_SystemUser" },
    {
      title: "Description",
      field: "description",
      defaultSort: "asc"
    },
    {
      title: "Checklist Form",
      field: "Description_CheckListForm"
    },
    {
      title: "Station",
      field: "Description_Station"
    },
    {
      title: "Location Details",
      field: "locationDetails",
      render: rowData => rowData.location_Details || ''
    },
    {
      title: "Comments",
      field: "comments"
    }
  ];

  static attributes = Checklist.columns.map((r) => r.field);

  static expand = [
    {
      'CheckListForm': {
        select: ['ChecklistFormId', 'Description']
      }
    },
    {
      'Station': {
        select: ['StationId', 'Description']
      }
    },
    {
      'Ihwi': {
        expand: [
          {
            "Inspection": {
              select: ["InspectionNumber"]
            }
          },
          {
            "Inspection": {
              expand:
              {
                "Rassignment": {
                  expand:
                  {
                    "SystemUser": { "select": ["Name"] }
                  }
                }
              }
            }
          }
        ]
      }
    }
  ];

  constructor(args) {
    super(args, Checklist.attributes);
  }
}
